import { useEffect, useRef, useState } from 'react'
import styles from './HeaderClock.module.css'

function formatTime(date: Date) {
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${hours}:${minutes}`
}

export function HeaderClock() {
  const [time, setTime] = useState(() => formatTime(new Date()))
  const [flipKey, setFlipKey] = useState(0)
  const offsetRef = useRef(0)
  const prevRef = useRef(time)

  useEffect(() => {
    let cancelled = false

    const sync = async () => {
      try {
        const res = await fetch('/api/time', { credentials: 'include' })
        if (!res.ok) throw new Error(res.statusText)
        const data = (await res.json()) as { ms?: number }
        if (!cancelled) offsetRef.current = (data.ms || 0) - Date.now()
      } catch {
        if (!cancelled) offsetRef.current = 0
      }
    }

    const tick = () => {
      const next = formatTime(new Date(Date.now() + offsetRef.current))
      if (next !== prevRef.current) {
        prevRef.current = next
        setTime(next)
        setFlipKey((k) => k + 1)
      }
    }

    void sync().then(tick)
    const clockTimer = setInterval(tick, 1000)
    const syncTimer = setInterval(() => void sync(), 5 * 60 * 1000)

    return () => {
      cancelled = true
      clearInterval(clockTimer)
      clearInterval(syncTimer)
    }
  }, [])

  return (
    <div className={styles.clock} aria-label={`Время ${time}`} title="Время (сервер)">
      {time.split('').map((digit, index) =>
        digit === ':' ? (
          <span key={`colon-${index}`} className={styles.colon}>
            :
          </span>
        ) : (
          <span key={`${flipKey}-${index}`} className={styles.digit}>
            <span className={styles.prev}>{digit}</span>
            <span className={styles.next}>{digit}</span>
          </span>
        ),
      )}
    </div>
  )
}
